// John Eldhose 201906/12
import { RestfulPost } from './Restful';

export async function addRMA(data) {
  const rma = await RestfulPost('addRMA', {data: data}, (response) => {
      return response['data'];
    }, (error) => {
      console.log(error);
      return false;
    }
  );
  return rma;
}



// WEBPACK FOOTER //
// ./src/Api/addRMA.js